<template>
    <div class="textbox-input-wrapper">
        <div class="input-container relative">
            <textarea 
                :id="id" 
                v-model="internalValue" 
                :disabled="!enabled" 
                :required="field.required"
                class="textbox-input text-base text-[var(--charcoal-dark)] border border-[var(--bone)] focus:border-[var(--primary)] rounded-lg h-27 px-3 py-1 pr-10 bg-white w-full outline-0 resize-none" 
                :class="{ 'input-error': display_errors && error, 'input-disabled': !enabled }"
                rows="4"
                @input="$emit('update:value', internalValue); $emit('validate')" 
                :aria-describedby="errorId"
                :placeholder="field.placeholder || 'Enter your comments...'"
            ></textarea>
            <div class="input-icon w-5 h-5 absolute right-4 top-4">
                <svg class="max-w-full" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
                </svg>
            </div>
        </div>
        <div v-if="display_errors && error" class="error-message flex items-center text-sm text-[var(--error)]" :id="errorId">
            <svg class="max-w-full mr-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: { type: Object, required: true },
        value: { type: String, default: '' },
        enabled: { type: Boolean, default: true },
        display_errors: { type: Boolean, default: false },
        error: { type: String, default: '' },
        idSuffix: { type: String, default: '' }
    },
    computed: {
        id() { return `field-${this.field.id}${this.idSuffix}`; },
        errorId() { return `error-field-${this.field.id}${this.idSuffix}`; },
        internalValue: {
            get() { return this.value; },
            set(newValue) { this.$emit('update:value', newValue); }
        }
    }
};
</script>
